import type { TO_FileData } from '@stratumn/studio-shared';

//? selectedVariable is set in the component on spawn using the selectedVariableRef from the block datInfo
export const initialTOFileData: Omit<TO_FileData, 'selectedVariable'> = {
  title: 'Default File Title',
  viewType: 'File Compact'
};
